import { PrivateMainLayout } from "../../components/layout";
import Term from "./Term";

export default function TermMain() {
  return (
    <>
      <Term />
      {/* <Stack width="100%" sx={{ display: { xs: "block", lg: "none" } }} mt={5}>
        <MobileBarNavigation />
      </Stack> */}
    </>
  );
}
